import React, { memo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  main__heading: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginTop: 14,
  },
  tableCol1Header: {
    width: 34 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
  },
  tableCol3Header: {
    width: 35 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderTopLeftRadius: 0,
  },
  tableColLastHeader: {
    width: 25 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  tableColFirstHeader: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderTopLeftRadius: 0,
    alignItems: 'center',
  },

  tableColFirst: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    alignItems: 'center',
  },
  tableCol1: {
    width: 34 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
  },
  tableCol3: {
    width: 35 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
  },
  tableCollast: {
    width: 25 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    paddingLeft: 3,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingLeft: 3,
    paddingRight: 3,
  },
});

const ConcernsTable = ({ concerns }) => {
  return (
    <>
      <Text style={styles.main__heading}>Customer Concerns:</Text>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableColFirstHeader}>
            <Text style={styles.tableCellHeader}>Sr#</Text>
          </View>
          <View style={styles.tableCol1Header}>
            <Text style={styles.tableCellHeader}>Concern</Text>
          </View>
          <View style={styles.tableCol3Header}>
            <Text style={styles.tableCellHeader}>Tech Findings</Text>
          </View>

          <View style={styles.tableColLastHeader}>
            <Text style={styles.tableCellHeader}>Condition</Text>
          </View>
        </View>

        {concerns?.map((con, i) => (
          <View style={styles.tableRow} key={i++}>
            <View style={styles.tableColFirst}>
              <Text style={styles.tableCell}>{i + 1}</Text>
            </View>
            <View style={styles.tableCol1}>
              <Text style={styles.tableCell}>{con?.title}</Text>
            </View>
            <View style={styles.tableCol3}>
              <Text style={styles.tableCell}>{con?.description}</Text>
            </View>

            <View style={styles.tableCollast}>
              <Text style={styles.tableCell}>
                {con?.condition === 'bad'
                  ? 'Immediate Action Required'
                  : con?.condition === 'moderate'
                  ? 'Parts Need Attention'
                  : 'Ok'}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </>
  );
};
export default memo(ConcernsTable);
